import FieldSet from '../../FieldSet';
import { DetailedEstimate } from './DetailedEstimate';
import { DetailedEstimateWithIcon } from './DetailedEstimateWithIcon';

export class DetailedEstimateFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [DetailedEstimate, DetailedEstimateWithIcon];
  }

  get title() {
    return 'Detailed estimate';
  }
}
